module.exports = __webpack_public_path__ + "static/media/system-oto-modulesF-img.7ab6c0c5.png";